/*
  Lets the filter drawer's <details> rows behave as the accordion the design draws.

  WHAT THIS FILE ACTUALLY DOES, because it is one line and the line is not obvious.

  Dawn's <menu-drawer> (assets/global.js:422) binds a click handler to every <summary>
  inside itself. For the drawer's own summary that handler opens the drawer, and that is
  wanted. For a filter's summary it does something else: it marks the row `menu-opening`,
  marks the list around it `submenu-open`, and traps keyboard focus inside the row's panel —
  the three moves that turn a filter into a panel sliding in over the drawer.

  The design has no sliding panel. It opens the values underneath the name, which is what a
  plain <details> already does, in every browser, with no script at all. So the whole of the
  work here is to keep Dawn's handler off those summaries and let the element be itself.

  A capture listener on the wrapper is what does it. Capture runs from the document down, so
  this sees the click before any handler bound to the summary itself and stopPropagation
  ends the journey there. Binding on the summary instead would not work — listeners on the
  element a click lands on run in the order they were added, and Dawn's was added first.

  Two things follow from stopping the event this early, and both are the point rather than a
  cost. Focus is never trapped, so tab still walks from one filter to the next and reaches
  the button at the foot of the drawer. And nothing has to fight Dawn in CSS: without
  `submenu-open` the list is never hidden, and without `menu-opening` the panel is never
  translated off to the side.

  Clear All is the exception, and it has to be. It lives inside the summary, so a blanket
  stop would swallow its click before <facet-remove> could act on it and the link would do
  nothing — or worse, follow its href and reload the page.

  Nothing here is required for the drawer to work. With this file absent or broken the rows
  become Dawn's sliding panels again: a different shape, still fully usable, still filtering.
  With no JavaScript at all the browser opens the <details> natively and the accordion is
  the accordion.
*/

const FACET_DRAWER_SELECTOR = '[data-kl-facet-drawer]';
const FACET_SUMMARY_SELECTOR = '[data-kl-facet-summary]';
const FACET_CLEAR_SELECTOR = '[data-kl-facet-clear]';

function handleFacetDrawerClick(event) {
  const summaryElement = event.target.closest(FACET_SUMMARY_SELECTOR);

  if (!summaryElement) return;
  if (event.target.closest(FACET_CLEAR_SELECTOR)) return;

  event.stopPropagation();
}

function initFacetDrawer(drawerElement) {
  if (!drawerElement) return;

  drawerElement.addEventListener('click', handleFacetDrawerClick, true);
}

document.querySelectorAll(FACET_DRAWER_SELECTOR).forEach(initFacetDrawer);
